'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';

import { HiOutlineArrowDownCircle } from 'react-icons/hi2';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function PriceLists({ documents }: { documents: TDynamicData[] }) {
  return (
    <section className={cn('custom-section', 'pb-8 pt-8 sm:pb-12 md:pb-16 lg:pb-[72px]')}>
      <div
        className={cn('custom-container', 'flex flex-col items-start justify-start gap-4 sm:gap-6')}
      >
        {documents.map(document => (
          <DocumentCard key={document.id} document={document} />
        ))}
      </div>
    </section>
  );
}

function DocumentCard({ document }: { document: TDynamicData }) {
  const { t } = useTranslations();

  return (
    <div className="flex w-full flex-col items-start justify-start gap-4 rounded-[16px] border border-[#BCBCBC] p-4 sm:flex-row sm:justify-between md:p-5 lg:p-6">
      <div className="flex items-center justify-start gap-6">
        <Image
          src={'/images/pdf.svg'}
          alt={document.name}
          width={0}
          height={0}
          className="max-h-12 min-h-12 min-w-[39px] max-w-[39px]"
        />
        <p className="text-sm font-medium tracking-tighter md:text-base lg:text-lg">
          {document.name}
        </p>
      </div>
      <Button asChild className="w-full sm:w-auto">
        <Link prefetch={false} target="_blank" href={document.fields[0]?.file?.url}>
          <HiOutlineArrowDownCircle size={24} /> {t('text3202')}
        </Link>
      </Button>
    </div>
  );
}
